"use strict";
/* globals module */
/**
 *@module lookupRoute
 * @description Baasic Lookup Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Lookup Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var LookupRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LookupRoute, _super);
    function LookupRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/{?embed,fields}';
        /**
        * Get access section route with route and query parameters.
        **/
        _this.getAccessSectionRoute = 'lookups/access-sections';
        return _this;
    }
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example baasicLookupRouteService.get(data);
     **/
    LookupRoute.prototype.get = function (data) {
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    var _a;
    LookupRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LookupRoute);
    return LookupRoute;
}(common_1.BaseRoute));
exports.LookupRoute = LookupRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
